import React from "react";

/* Значки досок канваса (build.py ic()): штрих 2, скруглённые концы. */

const PATHS = {
    x: ["M18 6L6 18", "M6 6l12 12"],
    check: ["M20 6L9 17l-5-5"],
    msg: ["M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"],
    chev: ["M9 18l6-6-6-6"],
    swap: ["M4 8h15", "M15.5 4.5L19 8l-3.5 3.5", "M20 16H5", "M8.5 12.5L5 16l3.5 3.5"],
} as const;

export type PlanIconName = keyof typeof PATHS | "search" | "clock" | "gift" | "phone" | "lock";

export const PlanIcon: React.FC<{ name: PlanIconName; size?: number; color?: string; stroke?: number }> = ({
    name,
    size = 20,
    color = "currentColor",
    stroke = 2,
}) => {
    const common = {
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: stroke,
        strokeLinecap: "round" as const,
        strokeLinejoin: "round" as const,
        "aria-hidden": true,
        style: { display: "block", flex: "none" },
    };
    if (name === "search")
        return (
            <svg {...common}>
                <circle cx="11" cy="11" r="7" />
                <path d="M20 20l-3.5-3.5" />
            </svg>
        );
    if (name === "clock")
        return (
            <svg {...common}>
                <circle cx="12" cy="12" r="9" />
                <path d="M12 7v5l3 2" />
            </svg>
        );
    if (name === "gift")
        return (
            <svg {...common}>
                <rect x="3" y="8" width="18" height="4" rx="1" />
                <path d="M12 8v13" />
                <path d="M19 12v7a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-7" />
                <path d="M7.5 8a2.5 2.5 0 0 1 0-5C11 3 12 8 12 8s1-5 4.5-5a2.5 2.5 0 0 1 0 5" />
            </svg>
        );
    if (name === "phone")
        return (
            <svg {...common}>
                <rect x="6" y="2" width="12" height="20" rx="2.5" />
                <path d="M11 18h2" />
            </svg>
        );
    if (name === "lock")
        return (
            <svg {...common}>
                <rect x="4" y="11" width="16" height="10" rx="2" />
                <path d="M8 11V7a4 4 0 0 1 8 0v4" />
            </svg>
        );
    return (
        // «›» справа налево (арабский) смотрит влево — app/styles/rtl.scss
        <svg {...common} {...(name === "chev" ? { "data-rtl-flip": "" } : {})}>
            {PATHS[name].map((d) => (
                <path key={d} d={d} />
            ))}
        </svg>
    );
};
